<!--
 * @Author: v_hllhe
 * @Date: 2022-12-20 17:22:22
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-22 18:05:30
 * @Description:
-->
<template>
<div>
    <div :class="{circle: true, warn: warning? true: false}" v-if="type === 'white'">
    </div>
    <div class="blue" v-if="type === 'blue'" >
    </div>
</div>

</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  name: '',
  props: {
    type: {
      type: String,
      default: 'white',
    },
    // 是否告警
    warning: {
      type: Boolean,
      default: false,
    },
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() { // 路由离开钩子
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/convert-viewport";
.circle{
  width: vw(220);
  height: vw(220);
  background: url('~@/assets/circle.png');
  background-size: 100% 100%;
  animation: rotate 3s linear infinite;
}
.blue{
  width: vw(220);
  height: vw(220);
  background: url('~@/assets/bottomCircle.png');
  background-size: 100% 100%;
  animation: rotate 3s linear infinite;
}
.circle:before{
  content: '';
  width: vw(188);
  height: vw(188);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 100%;
}
.warn:before{
  animation: glowGif 2s linear infinite;
}

@keyframes rotate {
    0%{-webkit-transform:rotate(0deg); }
    50%{-webkit-transform:rotate(180deg);}
    100%{-webkit-transform:rotate(360deg);}
}
@keyframes myfirst {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(0px, -50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes glowGif {
  0% {
       box-shadow:
            0 0 0 transparent,
            0 0 0 transparent,
  }
  50% {
    box-shadow:
    0 0 20px  rgba(255, 0, 0, 0.5),
    0 0 20px  rgba(255, 0, 0, 0.5);
  }
  0% {
     box-shadow:
            0 0 0 transparent,
            0 0 0 transparent,
  }
}
</style>
